import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  wallInputGroup: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 6
  },
})

export default useStyles